module.exports = __webpack_public_path__ + "img/logo-golog_720.482233c2.png";